var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDropDown = function SvgArrowDropDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 4,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#43A4D1",
    d: "M2.694 3.444.579 1.329a.275.275 0 0 1-.087-.204q0-.117.08-.204A.27.27 0 0 1 .783.833h4.434q.131 0 .211.088.08.087.08.204 0 .03-.087.204L3.306 3.444a.44.44 0 0 1-.146.102.4.4 0 0 1-.16.029.4.4 0 0 1-.16-.03.44.44 0 0 1-.146-.101"
  })));
};
export default SvgArrowDropDown;